import { HttpTypes } from '@/types';
import { AxiosInstance } from 'axios';

class WhatsAppWidget {
  private client: AxiosInstance;
  private routePath = '/sites';
  public host = '';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async get(): Promise<HttpTypes.IResponse<HttpTypes.WhatsAppWidgetResponse>> {
    const result = await this.client.get(`${this.routePath}/whatsapp-desk`, {
      headers: {
        Origin: this.host,
        'X-Jstore-Host': this.host,
      },
    });
    return result.data;
  }
}

export default WhatsAppWidget;
